<template>
  <div class="app-container">
    <el-row>
      <el-col>
        <el-form class="form">
          <el-form-item label="申请时间">
            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getListPatientCodiags">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table v-loading="listLoading" :data="manageList" fit highlight-current-row>
          <el-table-column align="center" label="申请时间" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.applyCodiagTime }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名" width="100px">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="性别" width="50px">
            <template slot-scope="scope">
              <span>{{ getGender(scope.row.gender) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="年龄" width="50px">
            <template slot-scope="scope">
              <span>{{ getAge(scope.row.birthday) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="电话">
            <template slot-scope="scope">
              <span>{{ scope.row.phone }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="联系人">
            <template slot-scope="scope">
              <span>{{ scope.row.contactName }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="联系人电话">
            <template slot-scope="scope">
              <span>{{ scope.row.contactPhone }}</span>
            </template>
          </el-table-column> -->

          <el-table-column align="center" label="发起人">
            <template slot-scope="scope">
              <span>{{ scope.row.applyDoctorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="发起机构">
            <template slot-scope="scope">
              <span>{{ scope.row.applyHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊人">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagDoctorName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊机构">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="诊断详情">
            <template slot-scope="scope">
              <el-button size="mini" @click="diagnose(scope.row)">诊断详情</el-button>
              <diagnoseDetailDialog v-if="diagnoseDetailVisible" ref="diagnoseRef"></diagnoseDetailDialog>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊">
            <template slot-scope="scope">
              <el-button size="mini" @click="consultationDetail(scope.row)">协诊详情</el-button>
              <consultationDetailDialog v-if="consultationDetailVisible" ref="consultationDetail">
              </consultationDetailDialog>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getListPatientCodiags, turnToMyCodiagDone, getByIdCoDiag, getSysDicList } from "@/api/health/Patients";
import consultationDetailDialog from "./bloodPressure/consultationDetailDialog.vue"
import diagnoseDetailDialog from "./bloodPressure/diagnoseDetailDialog.vue";
import Pagination from "@/components/Pagination";

export default {
  components: { diagnoseDetailDialog, Pagination, consultationDetailDialog },
  props: {
    pInfo: null
  },
  data() {
    return {
      valueData: null,
      manageList: [],
      listLoading: false,
      diagnoseDetailVisible: false,
      consultationDetailVisible: false,
      total: 0,
      data: null,
      listQuery: {
        codiagServiceName: '高血压协诊',
        pageNum: 1,
        pageSize: 10,
        patientName: null,
        idcard: null,
        managerHospitals: [],
        startTime: null,
        endTime: null
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      sexOptions: [],
    }

  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);

    this.getListPatientCodiags();
  },
  methods: {
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    // 协诊完成之后刷新列表
    upDataList() {
      this.turnToPage();
    },
    // 获取我发起的列表
    getListPatientCodiags() {
      this.listQuery.patientName = this.pInfo.name;
      this.listQuery.idcard = this.pInfo.idcard;
      this.listQuery.startTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.endTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      this.listLoading = true;
      getListPatientCodiags(this.listQuery).then(res => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      })
    },
    // 跳转协诊详情
    consultationDetail(data) {
      this.consultationDetailVisible = true;
      const params = {
        id: data.id
      }
      getByIdCoDiag(params).then(res => {
        if (res.msg == "success") {
          this.$nextTick(() => {
            this.$refs["consultationDetail"].init(res.data)
          })
        }
      })
    },
    // 計算年齡
    getAge(birthday) {
      if (birthday == null) return "";
      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    // 跳转诊断列表
    diagnose(rowValue) {
      this.diagnoseDetailVisible = true;
      this.$nextTick(() => {
        this.$refs.diagnoseRef.init(rowValue);
      })
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      this.listQuery.patientName = this.pInfo.name;
      this.listQuery.idcard = this.pInfo.idcard;
      this.listQuery.startTime = this.valueData ? this.getParseDate(this.valueData[0], 1) : null;
      this.listQuery.endTime = this.valueData ? this.getParseDate(this.valueData[1], 2) : null;

      turnToMyCodiagDone(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD HH:mm");
    },
  }
}
</script>
<style lang="scss" scoped>
.form {
  display: flex;

  ::v-deep {
    .el-form-item__content {
      display: flex;
    }
  }
}

::v-deep {
  .el-form-item {
    margin-left: 5px;
  }

  .cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>